import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '@base/base.service';
import { User } from './models/user.model';

@Injectable()
export class UsersService extends BaseService<User> {
  serviceUrl = '/api/users';

  generateToken(id: string): Observable<{ token: string; tokenPrefix: string }> {
    return this.http.post<{ token: string; tokenPrefix: string }>(`${this.serviceUrl}/${id}/token`, {});
  }

  revokeToken(id: string): Observable<{ revoked: boolean }> {
    return this.http.delete<{ revoked: boolean }>(`${this.serviceUrl}/${id}/token`);
  }
}
